(function() {
  'use strict';

  function UserViewController($scope, Auth, User, Users, Security, Utils) {
    var ctrl = this;

    function loadPermissions() {
      var editPermission = 'users.edit';
      var reviewPermission = 'users.review';
      var manageCredentialPermission = 'credential.manage';

      var editCheck = ctrl.remoteUser
        ? Security.checkPermissionFor(editPermission, ctrl.user)
        : Security.checkPermission(editPermission + '.own');

      editCheck.then(function(res) {
        ctrl.hasEditPermission = res;
      });

      Security.checkPermissionFor(reviewPermission, ctrl.user)
        .then(function(res) {
          ctrl.canReview = res;
        });

      Security.checkPermissionFor(manageCredentialPermission, ctrl.user)
        .then(function(res) {
          ctrl.hasManageCredentialPermission = res;
        });
    }

    function loadProfile() {
      return Users.find(ctrl.user)
        .then(function(profile) {
          ctrl.userObj = new User(profile);
          ctrl.profile = profile;

          if (ctrl.remoteUser) {
            var fullName = _.trim(
              (ctrl.profile.firstName || '') + ' ' + (ctrl.profile.lastName || '')
            );
            Utils.setPageTitle(fullName + '\'s profile');
          } else {
            Utils.setPageTitle('My profile');
          }

          ctrl.userIsDisabled = profile.state === 'disabled';
          ctrl.actionButtons = ctrl.userObj.profileActionButtons();
        })
        .catch(Utils.showError)
        .finally(function() {
          ctrl.loaded = true;
        });
    }

    // Users.remoteUser proxies a router signal that is only populated on
    // NavigationEnd, which fires after this component is instantiated. Snapshot
    // it once per load and re-run when it settles on a different user.
    function load() {
      ctrl.remoteUser = Users.remoteUser;
      ctrl.user = ctrl.remoteUser || Auth.currentUser();

      if (!ctrl.user) {
        return;
      }

      ctrl.loadedUser = ctrl.user;
      ctrl.userIsDisabled = false;
      ctrl.hasEditPermission = false;
      ctrl.hasManageCredentialPermission = false;
      ctrl.canReview = false;

      loadProfile();
      loadPermissions();
    }

    ctrl.$onInit = function() {
      load();

      $scope.$on('routerEvents:NavigationEnd', function() {
        var user = Users.remoteUser || Auth.currentUser();
        if (user !== ctrl.loadedUser) {
          load();
        }
      });
    };

    ctrl.reloadUser = function(doc) {
      ctrl.profile = doc;
      ctrl.userIsDisabled = ctrl.profile.state === 'disabled';
      ctrl.actionButtons = ctrl.userObj.profileActionButtons();
    };

    ctrl.approve = function() {
      return Users.updateState(ctrl.profile, 'user_approve')
        .then(function() {
          return Users.find(ctrl.profile.username, { noCache: true });
        })
        .then(function(doc) {
          ctrl.reloadUser(doc);
        })
        .catch(Utils.showError);
    };

    $scope.$on('KZUserReloaded', function(_evt, args) {
      if (args && args.doc.user === ctrl.profile.user) {
        ctrl.reloadUser(args.doc);
      }
    });
  }

  UserViewController.$inject = [
    '$scope',
    'AuthService',
    'UserFactory',
    'UsersService',
    'SecurityService',
    'UtilsService'
  ];

  angular.module('component.users')
    .component('userViewComponent', {
      controller: UserViewController,
      controllerAs: 'userViewCtrl',
      templateUrl: 'app/components/users/view.html'
    });
})();
